import { IFsLprProviderInterface } from '../api';

export interface AlprExportDialogData {
  providers: IFsLprProviderInterface[];
  totalResults: {
    total: number;
    totalQueryResults: number;
  };
  activeProvider?: IFsLprProviderInterface | null;
}

export interface AlprCsvExportConfiguration {
  exportAll: boolean;
  selectedProvider?: IFsLprProviderInterface;
}

